<script lang="ts">
    import AuditLogReportListing from '../../components/admin/report/auditLog/auditLogReportListing.svelte';
  </script>
  
  <div class="audit-log-report-listing-page">
    <AuditLogReportListing />
  </div>
  
  <style>
    .audit-log-report-listing-page {
      min-height: 100vh;
      background-color: #f9fafb;
    }
  </style>      